import axios from "axios";

export const saveStage = (courseId, postulationId, stageId, data, callback) => {
  var promise = axios({
    method: "patch",
    url: `/api/courses/${courseId}/postulation_bases/${postulationId}/stage_bases/${stageId}`,
    data: data,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
